import clsx from 'clsx';
import { FC } from 'react';
import { ReactComponent as ArrowRight } from '../../assets/icon/arrow_right.svg';
import { Link } from '../../components/Link.client';
import { venderMenuItems } from '../../constants/VenderMenu';

interface Props {
  selected: typeof venderMenuItems[number]['key'];
}

export const VenderMenu: FC<Props> = ({ selected }) => (
  <div
    className={clsx(
      'mb-16 flex flex-col gap-7 px-11 md:my-20 md:flex-row md:justify-center',
      selected === 'about' ? 'mt-7' : 'mt-11',
    )}
  >
    {venderMenuItems.map((item) => (
      <Link key={item.key} {...item.route}>
        <div
          className={clsx(
            'flex items-center justify-center gap-1 py-2 md:px-3',
            selected === item.key ? 'bg-thinSkyBlue' : 'border border-solid border-selected',
          )}
        >
          <p className={clsx('text-sm', selected === item.key ? 'text-white' : '')}>{item.title}</p>
          <div>
            <ArrowRight fill={selected === item.key ? 'white' : 'black'} width={16} height={7} />
          </div>
        </div>
      </Link>
    ))}
  </div>
);
